import Employees from './Employees'

export { Employees }

export enum ScopeGroup {
  Admin = '4',
  Cleaning = '1',
  Investor = '2',
  Reception = '3',
  Full = '5',
  Own = '0',
}

export const mapScopeGroupToString = (scopeGroup: ScopeGroup) => {
  switch (scopeGroup) {
    case ScopeGroup.Admin:
      return 'BED_3610_administrator'
    case ScopeGroup.Cleaning:
      return 'BED_3610_cleaning_staff'
    case ScopeGroup.Investor:
      return 'BED_3610_investor'
    case ScopeGroup.Reception:
      return 'BED_3610_reception'
    case ScopeGroup.Full:
      return 'BED_5712_full_access'
    case ScopeGroup.Own:
      return 'BED_3610_own'
    default:
      return 'BED_3610_own'
  }
}

export const mapScopeGroupToENString = (scopeGroup: ScopeGroup) => {
  switch (scopeGroup) {
    case ScopeGroup.Admin:
      return 'Administrator'
    case ScopeGroup.Cleaning:
      return 'Cleaning service'
    case ScopeGroup.Investor:
      return 'Investor'
    case ScopeGroup.Reception:
      return 'Reception'
    case ScopeGroup.Full:
      return 'Full Access'
    case ScopeGroup.Own:
      return 'Own'
    default:
      return 'Own'
  }
}

export enum PermissionScope {
  'SCOPE_CAN_BUY_PREMIUM' = 'SCOPE_CAN_BUY_PREMIUM',
  'SCOPE_CAN_USE_SEARCH' = 'SCOPE_CAN_USE_SEARCH',
  'SCOPE_CAN_EDIT_ROOMS' = 'SCOPE_CAN_EDIT_ROOMS',
  'SCOPE_CAN_USE_SYNC_INTEGRATIONS' = 'SCOPE_CAN_USE_SYNC_INTEGRATIONS',
  'SCOPE_CAN_EDIT_RESERVATIONS' = 'SCOPE_CAN_EDIT_RESERVATIONS',
  'SCOPE_CAN_VIEW_RESERVATIONS' = 'SCOPE_CAN_VIEW_RESERVATIONS',
  'SCOPE_HIDE_CLIENT_DATA' = 'SCOPE_HIDE_CLIENT_DATA',
  'SCOPE_CAN_VIEW_LIST_RESERVATIONS' = 'SCOPE_CAN_VIEW_LIST_RESERVATIONS',
  'SCOPE_CAN_USE_WIDGET' = 'SCOPE_CAN_USE_WIDGET',
  'SCOPE_CAN_USE_EXPORT' = 'SCOPE_CAN_USE_EXPORT',
  'SCOPE_CAN_USE_TASKS_INCOMING' = 'SCOPE_CAN_USE_TASKS_INCOMING',
  'SCOPE_CAN_USE_TASKS_CLEANING' = 'SCOPE_CAN_USE_TASKS_CLEANING',
  'SCOPE_CAN_USE_TASKS_FOOD' = 'SCOPE_CAN_USE_TASKS_FOOD',
  'SCOPE_CAN_USE_TASKS_PAYMENTS' = 'SCOPE_CAN_USE_TASKS_PAYMENTS',
  'SCOPE_CAN_USE_LIST_CLIENTS' = 'SCOPE_CAN_USE_LIST_CLIENTS',
  'SCOPE_CAN_USE_PROFILE' = 'SCOPE_CAN_USE_PROFILE',
  'SCOPE_CAN_USE_PRICING_AND_RESTRICTIONS' = 'SCOPE_CAN_USE_PRICING_AND_RESTRICTIONS',
  'SCOPE_CAN_USE_PRICING_SETTINGS' = 'SCOPE_CAN_USE_PRICING_SETTINGS',
  'SCOPE_CAN_USE_INVOICES' = 'SCOPE_CAN_USE_INVOICES',
  'SCOPE_CAN_USE_INVOICES_SETTINGS' = 'SCOPE_CAN_USE_INVOICES_SETTINGS',
  'SCOPE_CAN_USE_FINANCIAL_REPORTS' = 'SCOPE_CAN_USE_FINANCIAL_REPORTS',
  'SCOPE_CAN_USE_OCCUPANCY_REPORTS' = 'SCOPE_CAN_USE_OCCUPANCY_REPORTS',
  'SCOPE_CAN_USE_INTEGRATIONS_SETTINGS' = 'SCOPE_CAN_USE_INTEGRATIONS_SETTINGS',
  'SCOPE_CAN_USE_GLOBAL_SETTINGS' = 'SCOPE_CAN_USE_GLOBAL_SETTINGS',
  'SCOPE_CAN_USE_TEMPLATES' = 'SCOPE_CAN_USE_TEMPLATES',
  'SCOPE_CAN_USE_PERMISSIONS' = 'SCOPE_CAN_USE_PERMISSIONS',
}

export const ScopeGroupPermissions = {
  [ScopeGroup.Full]: {
    [PermissionScope.SCOPE_CAN_BUY_PREMIUM]: true,
    [PermissionScope.SCOPE_CAN_USE_SEARCH]: true,
    [PermissionScope.SCOPE_CAN_EDIT_ROOMS]: true,
    [PermissionScope.SCOPE_CAN_USE_SYNC_INTEGRATIONS]: true,
    [PermissionScope.SCOPE_CAN_EDIT_RESERVATIONS]: true,
    [PermissionScope.SCOPE_CAN_VIEW_RESERVATIONS]: true,
    [PermissionScope.SCOPE_HIDE_CLIENT_DATA]: true,
    [PermissionScope.SCOPE_CAN_VIEW_LIST_RESERVATIONS]: true,
    [PermissionScope.SCOPE_CAN_USE_WIDGET]: true,
    [PermissionScope.SCOPE_CAN_USE_EXPORT]: true,
    [PermissionScope.SCOPE_CAN_USE_TASKS_INCOMING]: true,
    [PermissionScope.SCOPE_CAN_USE_TASKS_CLEANING]: true,
    [PermissionScope.SCOPE_CAN_USE_TASKS_FOOD]: true,
    [PermissionScope.SCOPE_CAN_USE_TASKS_PAYMENTS]: true,
    [PermissionScope.SCOPE_CAN_USE_LIST_CLIENTS]: true,
    [PermissionScope.SCOPE_CAN_USE_PROFILE]: true,
    [PermissionScope.SCOPE_CAN_USE_PRICING_AND_RESTRICTIONS]: true,
    [PermissionScope.SCOPE_CAN_USE_PRICING_SETTINGS]: true,
    [PermissionScope.SCOPE_CAN_USE_INVOICES]: true,
    [PermissionScope.SCOPE_CAN_USE_INVOICES_SETTINGS]: true,
    [PermissionScope.SCOPE_CAN_USE_FINANCIAL_REPORTS]: true,
    [PermissionScope.SCOPE_CAN_USE_OCCUPANCY_REPORTS]: true,
    [PermissionScope.SCOPE_CAN_USE_INTEGRATIONS_SETTINGS]: true,
    [PermissionScope.SCOPE_CAN_USE_GLOBAL_SETTINGS]: true,
    [PermissionScope.SCOPE_CAN_USE_TEMPLATES]: true,
    [PermissionScope.SCOPE_CAN_USE_PERMISSIONS]: true,
  },
  [ScopeGroup.Admin]: {
    [PermissionScope.SCOPE_CAN_BUY_PREMIUM]: true,
    [PermissionScope.SCOPE_CAN_USE_SEARCH]: true,
    [PermissionScope.SCOPE_CAN_EDIT_ROOMS]: true,
    [PermissionScope.SCOPE_CAN_USE_SYNC_INTEGRATIONS]: true,
    [PermissionScope.SCOPE_CAN_EDIT_RESERVATIONS]: false,
    [PermissionScope.SCOPE_CAN_VIEW_RESERVATIONS]: true,
    [PermissionScope.SCOPE_HIDE_CLIENT_DATA]: false,
    [PermissionScope.SCOPE_CAN_VIEW_LIST_RESERVATIONS]: false,
    [PermissionScope.SCOPE_CAN_USE_WIDGET]: true,
    [PermissionScope.SCOPE_CAN_USE_EXPORT]: true,
    [PermissionScope.SCOPE_CAN_USE_TASKS_INCOMING]: false,
    [PermissionScope.SCOPE_CAN_USE_TASKS_CLEANING]: false,
    [PermissionScope.SCOPE_CAN_USE_TASKS_FOOD]: false,
    [PermissionScope.SCOPE_CAN_USE_TASKS_PAYMENTS]: false,
    [PermissionScope.SCOPE_CAN_USE_LIST_CLIENTS]: false,
    [PermissionScope.SCOPE_CAN_USE_PROFILE]: true,
    [PermissionScope.SCOPE_CAN_USE_PRICING_AND_RESTRICTIONS]: true,
    [PermissionScope.SCOPE_CAN_USE_PRICING_SETTINGS]: true,
    [PermissionScope.SCOPE_CAN_USE_INVOICES]: true,
    [PermissionScope.SCOPE_CAN_USE_INVOICES_SETTINGS]: true,
    [PermissionScope.SCOPE_CAN_USE_FINANCIAL_REPORTS]: false,
    [PermissionScope.SCOPE_CAN_USE_OCCUPANCY_REPORTS]: false,
    [PermissionScope.SCOPE_CAN_USE_INTEGRATIONS_SETTINGS]: true,
    [PermissionScope.SCOPE_CAN_USE_GLOBAL_SETTINGS]: true,
    [PermissionScope.SCOPE_CAN_USE_TEMPLATES]: true,
    [PermissionScope.SCOPE_CAN_USE_PERMISSIONS]: true,
  },
  [ScopeGroup.Cleaning]: {
    [PermissionScope.SCOPE_CAN_BUY_PREMIUM]: false,
    [PermissionScope.SCOPE_CAN_USE_SEARCH]: false,
    [PermissionScope.SCOPE_CAN_EDIT_ROOMS]: false,
    [PermissionScope.SCOPE_CAN_USE_SYNC_INTEGRATIONS]: false,
    [PermissionScope.SCOPE_CAN_EDIT_RESERVATIONS]: false,
    [PermissionScope.SCOPE_CAN_VIEW_RESERVATIONS]: false,
    [PermissionScope.SCOPE_HIDE_CLIENT_DATA]: false,
    [PermissionScope.SCOPE_CAN_VIEW_LIST_RESERVATIONS]: false,
    [PermissionScope.SCOPE_CAN_USE_WIDGET]: false,
    [PermissionScope.SCOPE_CAN_USE_EXPORT]: false,
    [PermissionScope.SCOPE_CAN_USE_TASKS_INCOMING]: false,
    [PermissionScope.SCOPE_CAN_USE_TASKS_CLEANING]: true,
    [PermissionScope.SCOPE_CAN_USE_TASKS_FOOD]: true,
    [PermissionScope.SCOPE_CAN_USE_TASKS_PAYMENTS]: false,
    [PermissionScope.SCOPE_CAN_USE_LIST_CLIENTS]: false,
    [PermissionScope.SCOPE_CAN_USE_PROFILE]: false,
    [PermissionScope.SCOPE_CAN_USE_PRICING_AND_RESTRICTIONS]: false,
    [PermissionScope.SCOPE_CAN_USE_PRICING_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_INVOICES]: false,
    [PermissionScope.SCOPE_CAN_USE_INVOICES_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_FINANCIAL_REPORTS]: false,
    [PermissionScope.SCOPE_CAN_USE_OCCUPANCY_REPORTS]: false,
    [PermissionScope.SCOPE_CAN_USE_INTEGRATIONS_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_GLOBAL_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_TEMPLATES]: false,
    [PermissionScope.SCOPE_CAN_USE_PERMISSIONS]: false,
  },
  [ScopeGroup.Investor]: {
    [PermissionScope.SCOPE_CAN_BUY_PREMIUM]: false,
    [PermissionScope.SCOPE_CAN_USE_SEARCH]: false,
    [PermissionScope.SCOPE_CAN_EDIT_ROOMS]: false,
    [PermissionScope.SCOPE_CAN_USE_SYNC_INTEGRATIONS]: false,
    [PermissionScope.SCOPE_CAN_EDIT_RESERVATIONS]: false,
    [PermissionScope.SCOPE_CAN_VIEW_RESERVATIONS]: false,
    [PermissionScope.SCOPE_HIDE_CLIENT_DATA]: false,
    [PermissionScope.SCOPE_CAN_VIEW_LIST_RESERVATIONS]: false,
    [PermissionScope.SCOPE_CAN_USE_WIDGET]: false,
    [PermissionScope.SCOPE_CAN_USE_EXPORT]: false,
    [PermissionScope.SCOPE_CAN_USE_TASKS_INCOMING]: false,
    [PermissionScope.SCOPE_CAN_USE_TASKS_CLEANING]: false,
    [PermissionScope.SCOPE_CAN_USE_TASKS_FOOD]: false,
    [PermissionScope.SCOPE_CAN_USE_TASKS_PAYMENTS]: false,
    [PermissionScope.SCOPE_CAN_USE_LIST_CLIENTS]: false,
    [PermissionScope.SCOPE_CAN_USE_PROFILE]: false,
    [PermissionScope.SCOPE_CAN_USE_PRICING_AND_RESTRICTIONS]: false,
    [PermissionScope.SCOPE_CAN_USE_PRICING_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_INVOICES]: false,
    [PermissionScope.SCOPE_CAN_USE_INVOICES_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_FINANCIAL_REPORTS]: true,
    [PermissionScope.SCOPE_CAN_USE_OCCUPANCY_REPORTS]: true,
    [PermissionScope.SCOPE_CAN_USE_INTEGRATIONS_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_GLOBAL_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_TEMPLATES]: false,
    [PermissionScope.SCOPE_CAN_USE_PERMISSIONS]: false,
  },
  [ScopeGroup.Reception]: {
    [PermissionScope.SCOPE_CAN_BUY_PREMIUM]: true,
    [PermissionScope.SCOPE_CAN_USE_SEARCH]: true,
    [PermissionScope.SCOPE_CAN_EDIT_ROOMS]: false,
    [PermissionScope.SCOPE_CAN_USE_SYNC_INTEGRATIONS]: true,
    [PermissionScope.SCOPE_CAN_EDIT_RESERVATIONS]: true,
    [PermissionScope.SCOPE_CAN_VIEW_RESERVATIONS]: true,
    [PermissionScope.SCOPE_HIDE_CLIENT_DATA]: true,
    [PermissionScope.SCOPE_CAN_VIEW_LIST_RESERVATIONS]: true,
    [PermissionScope.SCOPE_CAN_USE_WIDGET]: false,
    [PermissionScope.SCOPE_CAN_USE_EXPORT]: true,
    [PermissionScope.SCOPE_CAN_USE_TASKS_INCOMING]: true,
    [PermissionScope.SCOPE_CAN_USE_TASKS_CLEANING]: true,
    [PermissionScope.SCOPE_CAN_USE_TASKS_FOOD]: true,
    [PermissionScope.SCOPE_CAN_USE_TASKS_PAYMENTS]: true,
    [PermissionScope.SCOPE_CAN_USE_LIST_CLIENTS]: true,
    [PermissionScope.SCOPE_CAN_USE_PROFILE]: false,
    [PermissionScope.SCOPE_CAN_USE_PRICING_AND_RESTRICTIONS]: true,
    [PermissionScope.SCOPE_CAN_USE_PRICING_SETTINGS]: true,
    [PermissionScope.SCOPE_CAN_USE_INVOICES]: true,
    [PermissionScope.SCOPE_CAN_USE_INVOICES_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_FINANCIAL_REPORTS]: false,
    [PermissionScope.SCOPE_CAN_USE_OCCUPANCY_REPORTS]: false,
    [PermissionScope.SCOPE_CAN_USE_INTEGRATIONS_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_GLOBAL_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_TEMPLATES]: false,
    [PermissionScope.SCOPE_CAN_USE_PERMISSIONS]: false,
  },
  [ScopeGroup.Own]: {
    [PermissionScope.SCOPE_CAN_BUY_PREMIUM]: false,
    [PermissionScope.SCOPE_CAN_USE_SEARCH]: false,
    [PermissionScope.SCOPE_CAN_EDIT_ROOMS]: false,
    [PermissionScope.SCOPE_CAN_USE_SYNC_INTEGRATIONS]: false,
    [PermissionScope.SCOPE_CAN_EDIT_RESERVATIONS]: false,
    [PermissionScope.SCOPE_CAN_VIEW_RESERVATIONS]: false,
    [PermissionScope.SCOPE_HIDE_CLIENT_DATA]: false,
    [PermissionScope.SCOPE_CAN_VIEW_LIST_RESERVATIONS]: false,
    [PermissionScope.SCOPE_CAN_USE_WIDGET]: false,
    [PermissionScope.SCOPE_CAN_USE_EXPORT]: false,
    [PermissionScope.SCOPE_CAN_USE_TASKS_INCOMING]: false,
    [PermissionScope.SCOPE_CAN_USE_TASKS_CLEANING]: false,
    [PermissionScope.SCOPE_CAN_USE_TASKS_FOOD]: false,
    [PermissionScope.SCOPE_CAN_USE_TASKS_PAYMENTS]: false,
    [PermissionScope.SCOPE_CAN_USE_LIST_CLIENTS]: false,
    [PermissionScope.SCOPE_CAN_USE_PROFILE]: false,
    [PermissionScope.SCOPE_CAN_USE_PRICING_AND_RESTRICTIONS]: false,
    [PermissionScope.SCOPE_CAN_USE_PRICING_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_INVOICES]: false,
    [PermissionScope.SCOPE_CAN_USE_INVOICES_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_FINANCIAL_REPORTS]: false,
    [PermissionScope.SCOPE_CAN_USE_OCCUPANCY_REPORTS]: false,
    [PermissionScope.SCOPE_CAN_USE_INTEGRATIONS_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_GLOBAL_SETTINGS]: false,
    [PermissionScope.SCOPE_CAN_USE_TEMPLATES]: false,
    [PermissionScope.SCOPE_CAN_USE_PERMISSIONS]: false,
  },
}

export const PermissionList = [
  {
    scope: PermissionScope.SCOPE_CAN_BUY_PREMIUM,
    label: 'BKO_1130_premium',
    tooltip: 'BED_3610_premium_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_SEARCH,
    label: 'BED_3610_calendar_search',
    tooltip: 'BED_3610_calendar_search_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_EDIT_ROOMS,
    label: 'BED_3610_room_management',
    tooltip: 'BED_3610_room_management_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_SYNC_INTEGRATIONS,
    label: 'BED_3610_sales_channel',
    tooltip: 'BED_3610_sales_channels_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_EDIT_RESERVATIONS,
    label: 'BED_3610_adding_reservations',
    tooltip: 'BED_3610_adding_reservations_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_VIEW_RESERVATIONS,
    label: 'BED_3610_reservation_preview',
    tooltip: 'BED_3610_reservation_preview_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_HIDE_CLIENT_DATA,
    label: 'BED_3610_hide_information_quest',
    tooltip: 'BED_3610_hide_information_about_guest_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_VIEW_LIST_RESERVATIONS,
    label: 'menu_calendar_list',
    tooltip: 'BED_3610_calendar_list_tooltip_0_1',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_WIDGET,
    label: 'BBO_2891_menu_booking_engine',
    tooltip: 'BED_3610_menu_booking_engine_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_EXPORT,
    label: 'title_activity_export',
    tooltip: 'BED_3610_title_activity_export_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_TASKS_INCOMING,
    label: 'BED_3610_tasks_departure',
    tooltip: 'BED_3610_tasks_departure_tooltip_0_1',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_TASKS_CLEANING,
    label: 'BED_3610_tasks_cleaning',
    tooltip: 'BED_3610_tasks_cleaning_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_TASKS_FOOD,
    label: 'BED_3610_tasks_meals',
    tooltip: 'BED_3610_tasks_meals_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_TASKS_PAYMENTS,
    label: 'BED_3610_tasks_no_payment',
    tooltip: 'BED_3610_tasks_no_payment_tooltip_0_1',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_LIST_CLIENTS,
    label: 'menu_clients',
    tooltip: 'BED_3610_menu_clients_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_PROFILE,
    label: 'menu_profile',
    tooltip: 'BED_3610_menu_profile_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_PRICING_AND_RESTRICTIONS,
    label: 'BED_3610_setting_prices',
    tooltip: 'BED_3610_setting_prices_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_PRICING_SETTINGS,
    label: 'BED_3610_configure_price_list',
    tooltip: 'BED_3610_configure_price_list_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_INVOICES,
    label: 'BED_3610_access_invoice',
    tooltip: 'BED_3610_access_invoice_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_INVOICES_SETTINGS,
    label: 'BED_3610_invoice_settings',
    tooltip: 'BED_3610_invoice_settings_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_FINANCIAL_REPORTS,
    label: 'menu_finances_report',
    tooltip: 'BED_3610_menu_finances_report_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_OCCUPANCY_REPORTS,
    label: 'BED_3604_occupancy_report',
    tooltip: 'BED_3610_occupancy_report_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_INTEGRATIONS_SETTINGS,
    label: 'BED_3604_sales_channels',
    tooltip: 'BED_3610_config_connect_sales_channels_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_GLOBAL_SETTINGS,
    label: 'BED_3610_global_system_settings',
    tooltip: 'BED_3610_global_system_settings_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_TEMPLATES,
    label: 'custom_messages_title',
    tooltip: 'BED_3610_message_templates_tooltip',
  },
  {
    scope: PermissionScope.SCOPE_CAN_USE_PERMISSIONS,
    label: 'BED_3610_permission_management',
    tooltip: 'BED_3610_permission_management_tooltip',
  },
]
